import React from "react";

var linkedinSvg = function linkedinSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0077B5",
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    d: "M8.764 6.5a2.263 2.263 0 1 1-.003 4.525A2.263 2.263 0 0 1 8.764 6.5zM6.81 25.295V12.741h3.906v12.554H6.81zm6.353-12.554h3.74v1.716h.054c.52-.987 1.794-2.028 3.691-2.028 3.952 0 4.682 2.6 4.682 5.981v6.885h-3.902V19.19c0-1.456-.025-3.329-2.027-3.329-2.03 0-2.34 1.587-2.34 3.225v6.21h-3.898V12.74z"
  })));
};

linkedinSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "32",
  height: "32",
  viewBox: "0 0 32 32"
};
export var linkedin = {
  category: 'social',
  colorable: false,
  name: 'linkedin',
  svg: linkedinSvg
};